function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(1, 1)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#005a83",
  d: "M 3.5 1 C 2.675781 1 2 1.675781 2 2.5 L 2 13 L 1 13 L 1 14 L 12 14 L 12 13 L 11 13 L 11 8 L 11.5 8 C 11.777344 8 12 8.222656 12 8.5 L 12 10.5 C 12 11.191406 12.519531 11.6875 13.15625 11.859375 C 13.25 11.945313 13.371094 11.996094 13.5 12 C 14.324219 12 15 11.324219 15 10.5 L 15 5.125 C 15 5.046875 14.980469 4.96875 14.941406 4.898438 L 12.941406 1.023438 L 12.058594 1.476563 L 13 3.304688 L 13 5 L 14 7 L 14 10.5 C 14 10.777344 13.777344 11 13.5 11 C 13.222656 11 13 10.777344 13 10.5 L 13 8.5 C 13 7.808594 12.480469 7.3125 11.84375 7.140625 C 11.75 7.054688 11.628906 7.003906 11.5 7 L 11 7 L 11 2.5 C 11 1.675781 10.324219 1 9.5 1 Z M 3.5 2 L 9.5 2 C 9.78125 2 10 2.21875 10 2.5 L 10 13 L 3 13 L 3 2.5 C 3 2.21875 3.21875 2 3.5 2 Z M 4 3 L 4 7 L 9 7 L 9 3 Z M 5 4 L 8 4 L 8 6 L 5 6 Z",
  vectorEffect: "non-scaling-stroke"
}));

var SvgIcons8GasStation = function SvgIcons8GasStation(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    overflow: "visible",
    preserveAspectRatio: "none",
    viewBox: "0 0 18 18",
    width: 24,
    height: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcons8GasStation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icons8-gas_station.d119ab3c.svg";
export { ForwardRef as ReactComponent };